import request from '@/utils/request'

export function getIndustryConfig(query) {
  return request({
    url: '/index/report/getIndustryConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getIndustryPageData(query) {
  return request({
    url: '/index/report/getIndustryPageData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createIndustryReport(query) {
  return request({
    url: '/index/report/createIndustryReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function deleteIndustryReport(query) {
  return request({
    url: '/index/report/deleteIndustryReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function exportIndustryReport(query) {
  return request({
    url: '/index/report/exportIndustrReport',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getAbilityConfig(query) {
  return request({
    url: '/index/report/getAbilityConfig',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getAbilityPageData(query) {
  return request({
    url: '/index/report/getAbilityPageData',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function createJobAbilityReport(query) {
  return request({
    url: '/index/report/createJobAbilityReport',
    method: 'post',
    data: query
  })
}

export function deleteAbilityReport(query) {
  return request({
    url: '/index/report/deleteAbilityReport',
    method: 'post',
    data: query
  })
}


export function getTalentConfig(query) {
  return request({
    url: '/index/report/getTalentConfig',
    method: 'post',
    params: query
  })
}

export function getTalentPageData(query) {
  return request({
    url: '/index/report/getTalentPageData',
    method: 'post',
    params: query
  })
}

export function createTalentReport(query) {
  return request({
    url: '/index/report/createTalentReport',
    method: 'post',
    data: query
  })
}

export function deleteTalentReport(query) {
  return request({
    url: '/index/report/deleteTalentReport',
    method: 'post',
    params: query
  })
}

export function exportTalentReport(query) {
  return request({
    url: '/index/report/exportTalentReport',
    method: 'post',
    params: query
  })
}

export function getCourseConfig(query) {
  return request({
    url: '/index/report/getCourseConfig',
    method: 'post',
    params: query
  })
}

export function getCoursePageData(query) {
  return request({
    url: '/index/report/getCoursePageData',
    method: 'post',
    params: query
  })
}

export function createCourseReport(query) {
  return request({
    url: '/index/report/createCourseReport',
    method: 'post',
    data: query
  })
}

export function deleteCourseReport(query) {
  return request({
    url: '/index/report/deleteCourseReport',
    method: 'post',
    params: query
  })
}


export function exportCourseReport(query) {
  return request({
    url: '/index/report/exportCourseReport',
    method: 'post',
    params: query
  })
}


export function getTrainingConfig(query) {
  return request({
    url: '/index/report/getTrainingConfig',
    method: 'post',
    params: query
  })
}

export function getTrainingPageData(query) {
  return request({
    url: '/index/report/getTrainingPageData',
    method: 'post',
    params: query
  })
}

export function exportAbilityReport(query) {
  return request({
    url: '/index/report/exportAbilityReport',
    method: 'post',
    params: query
  })
}

export function getTargetConfig(query) {
  return request({
    url: '/index/report/getTargetConfig',
    method: 'post',
    params: query
  })
}

export function getTargetPageData(query) {
  return request({
    url: '/index/report/getTargetPageData',
    method: 'post',
    params: query
  })
}

export function createTargetReport(query) {
  return request({
    url: '/index/report/createTargetReport',
    method: 'post',
    data: query
  })
}

export function deleteTargetReport(query) {
  return request({
    url: '/index/report/deleteTargetReport',
    method: 'post',
    params: query
  })
}

export function streamTargetReport(query) {
  return request({
    url: '/index/report/streamTargetReport',
    method: 'post',
    params: query
  })
}

export function exportTargetReport(query) {
  return request({
    url: '/index/report/exportTargetReport',
    method: 'post',
    params: query
  })
}
